import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { NotesQuery } from '@modules/notes/state/notes-query';
import { NotesService } from '@modules/notes/services/notes.service';
import { RxNote } from '@modules/notes/models/rx-note';
import { IntuitiveNote } from './models/intuitive-note.model';

const rxNoteToIntuitive = (note: RxNote): IntuitiveNote => ({
	id: note.id != null ? String(note.id) : '',
	createdByName: note.createdByName ?? null,
	dateCreated: note.dateCreated ? new Date(note.dateCreated) : new Date(),
	content: note.content ?? ''
});

@Injectable()
export class IntuitiveNotesListFacade {
	notes$: Observable<IntuitiveNote[]> = this.notesQuery.notesArray$.pipe(map(notes => (notes ?? []).map(rxNoteToIntuitive)));

	constructor(
		private readonly notesService: NotesService,
		private readonly notesQuery: NotesQuery,
		private readonly shellQuery: ShellQuery
	) {}

	addNote(content: string, createdByName: string | null = null): void {
		const newNote = this.notesService.createNote({
			content,
			createdByName: createdByName ?? this.shellQuery.user?.Name ?? undefined,
			createdById: this.shellQuery.contactId ?? undefined,
			dateCreated: new Date().toISOString(),
			role: this.shellQuery.userRole ?? undefined
		});

		const updated = [newNote, ...(this.notesQuery.notesArray ?? [])];

		this.notesService.updateNotes(updated);
	}

	editNote(id: string, content: string): void {
		const updated = (this.notesQuery.notesArray ?? []).map(note =>
			(note.id != null ? String(note.id) : '') === id ? { ...note, content } : note
		);

		this.notesService.updateNotes(updated);
	}

	removeNote(id: string): void {
		const updated = (this.notesQuery.notesArray ?? []).filter(note => (note.id != null ? String(note.id) : '') !== id);

		this.notesService.updateNotes(updated);
	}
}
